module.exports = __webpack_public_path__ + "img/try-flambu-mobile.5012d3b7.webp";